import React, { useEffect, useReducer, useState } from 'react';
import TextInput from '../Common/TextInput';
import Notification from '../Common/Notification';
import ajaxSchool from '../../util/remote/ajaxSchool';
import CallOut from '../Common/CallOut';
import { useTheme } from '../../DataStore/ThemeContext';

const reducer = (state, action)=>{
    if(action.type === "RESET"){
        return {...initialState}
    }
    return { ...state, [action.type]: action.value };
}

const initialState = {
    bankCode: '',
    loading: false,
}


const ChangeSettlementBank = ({data}) => {
    const { selection, refresh } = data;

    const [state, dispatch] = useReducer(reducer, initialState);
    const [info, setInfo] = useState('');
    const {setSystemFunction} = useTheme();

    

    useEffect(()=>{
         setSystemFunction(() => handleSave);
        return ()=>{
            setSystemFunction(null);
        }
    }, [state])
    

    const handleSave=async()=>{
        if(!state.bankCode){
            setInfo(<Notification type="danger" message="Please enter the settlement bank code." closable={false}/>);
            return;
        }
        setInfo('');
        const server_response = await ajaxSchool.changeSettlementBank({new_bank_code: state.bankCode, ids: selection});
        if(server_response.status==="OK"){
            setInfo(<Notification type="success" message={server_response.message} closable={false}/>)
            refresh();
        }else{
            setInfo(<Notification type="danger" message={server_response.message} closable={false}/>)
        }

      
    }


    return ( <>
        <form method='post' onSubmit={handleSave}>

            <CallOut
                    title="Settlement Bank"
                    description={`Change the settlement bank on which the online payments will be settled. Please make sure the selected records are not already reconciled before changing the settlement bank. ${selection.length} record(s) will be affected.`}
                    />


                <div className='mt-4'>{info}</div>
                    <TextInput
                      type='text'
                      label='Settlement Bank'
                      placeholder='Enter settlement bank name'
                      leftIcon='fa fa-university'
                      value={state.bankCode}
                      onChange={e => dispatch({type: 'bankCode', value: e.target.value})}
                      required
                      wrap
                    />

                   
        </form>
        </>
    );
};

export default ChangeSettlementBank;